import React from 'react';
import { registerClass, subClass } from '@food/css-manager';
import { Icon } from '@food/ui/build/dist/src/icons';
import { SOCIAL } from '../types';
var socialButtons = registerClass(function (t, sc) { return "\n\t> button {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tcursor: pointer;\n\t\ttext-align: left;\n\t\tborder: none;\n\t\tmargin-bottom: " + t.font.baseSize + "px;\n\t\talign-items: stretch;\n\t\tpadding: " + t.font.baseSize + "px;\n\t\tfont-size: " + t.font.baseSize + "px;\n\t\t\n\t\t> span {\n\t\t\t&:first-child {\n\t\t\t\tfont-size: " + t.ratios.l * t.font.baseSize + "px;\n\t\t\t\tflex-shrink: 1;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tflex-grow: 1;\n\t\t\t\ttext-align: left;\n\t\t\t\tpadding-left: " + t.font.baseSize + "px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\n\t\t&." + sc('GOOGLE') + " {\n\t\t\tcolor: " + t.colors.white + ";\n\t\t\tbackground-color: #d34836;\n\t\t}\n\t\t&." + sc('FACEBOOK') + " {\n\t\t\tcolor: " + t.colors.white + ";\n\t\t\tbackground-color: #3b5998;\n\t\t}\n\t\t&." + sc('LINKEDIN') + " {\n\t\t\tcolor: " + t.colors.white + ";\n\t\t\tbackground-color: #0a74b4;\n\t\t}\n\t}\n"; });
function social2icon(s) {
    switch (s) {
        case SOCIAL.FACEBOOK:
            return 'facebook';
        case SOCIAL.GOOGLE:
            return 'google';
        case SOCIAL.LINKEDIN:
            return 'linkedin';
        default:
            return 'share';
    }
}
export var SocialButtons = function (_a) {
    var socials = _a.socials, onClick = _a.onClick, t = _a.t;
    return (React.createElement("div", { className: socialButtons }, socials.map(function (social) { return (React.createElement("button", { key: social, className: subClass(socialButtons, social), onClick: function () {
            return onClick !== undefined && onClick({ fixedSocial: social });
        } },
        React.createElement(Icon, { name: social2icon(social) }),
        React.createElement("span", null, t(social + " login button", "Sign in with " + social)))); })));
};
//# sourceMappingURL=SocialButtons.js.map